export type UnreadThread = {
  area?: "comercial" | "operaciones";
  hasUnread?: boolean;
  lastMessageAt?: any;
};

const millis = (value: any): number => {
  if (value?.toMillis) return value.toMillis();
  if (value?.toDate) return value.toDate().getTime();
  const parsed = value ? new Date(value).getTime() : 0;
  return Number.isNaN(parsed) ? 0 : parsed;
};

export const unreadThreadsForArea = <T extends UnreadThread>(
  threads: T[],
  area: "comercial" | "operaciones"
): T[] => threads
  .filter((thread) => thread.hasUnread && (thread.area || "comercial") === area)
  .sort((a, b) => millis(b.lastMessageAt) - millis(a.lastMessageAt));
